import {
  addSlidesTabIndex
} from '@gravity-global/helpers/swiper/add-slides-tab-index';

const dynamicSliderInit = () => {
  const mainPattern = document.querySelectorAll('.gg-insights-list');

  mainPattern.forEach((module) => {
    const swipers = module.querySelector('.posts-result');
    const swiperWrapper = module.querySelector('.gravity-block-dynamic-boxes--grid-view');
    const groupButton = module.querySelector('.gg-button-carousel__button-no-outline');
    if (swipers == null) {
      groupButton.classList.add('d-none');
    }
    if (!swipers || !swiperWrapper) {
      return;
    }

    const swiperSlides = module.querySelectorAll('.gravity-block-dynamic-boxes__box');
    const swiperNext = module.querySelector('.gg-button-carousel__button-no-outline__next-btn > a');
    const swiperPrev = module.querySelector('.gg-button-carousel__button-no-outline__prev-btn > a');
    const numberOfSlides = swiperSlides.length;

    // if(numberOfSlides > 5) {
    //   module.querySelector('.gg-insights-list__list-card').classList.add('max-width-xl-2304');
    // }

    if (swiperPrev) swiperPrev.setAttribute('rel', 'prev');
    if (swiperNext) swiperNext.setAttribute('rel', 'next');

    swipers.classList.add('swiper-container');
    swiperWrapper.classList.add('swiper-wrapper');
    swiperSlides.forEach((slide, index) => {
      slide.classList.add('swiper-slide', 'fade-in-up', `delay-${index}`);
    });

    const carousel = new window.Swiper(swipers, {
      loop: true,
      centeredSlides: false,
      watchOverflow: true,
      watchSlidesProgress: true,
      slidesPerGroup: 1,
      slidesPerView: 'auto',
      allowTouchMove: true,
      touchEventsTarget: "container" | "wrapper",
      navigation: {
        prevEl: swiperPrev,
        nextEl: swiperNext,
      },
      breakpoints: {
        1200: {
          slidesPerView: 'auto',
          spaceBetween: 40,
          loop: numberOfSlides <= 3 ? false : true
        },
        1025: {
          slidesPerView: 2.7,
          spaceBetween: 40,
        },
        750: {
          slidesPerView: 2.1,
          spaceBetween: 16,
          loop: numberOfSlides <= 2 ? false : true
        },
        480: {
          slidesPerView: 1.5,
          spaceBetween: 16,
          loop: numberOfSlides <= 1 ? false : true
        },
        200: {
          slidesPerView: 1.1,
          spaceBetween: 16,
          loop: numberOfSlides <= 1 ? false : true,
        },
      },
      on: {
        init: (swiper) => addSlidesTabIndex(swiper),
        slideChange: (swiper) => addSlidesTabIndex(swiper),
      },
    });
    carousel.init();
    if (typeof carousel.loopedSlides === 'undefined') {
      groupButton.classList.add('d-none');
    }
  });
};
dynamicSliderInit();
